import type { LockCodeRail } from '@citibox-panel/api-client';
import type { LockCodeWindow } from './lockCodeWindow';

export interface LockSequenceTarget {
  /** Where the server pointer stands now — metric only, never validated against devices. */
  oldPosition: number;
  /** Position of the next code to give once the confirmation lands. */
  newPosition: number;
}

// The two positions a confirmation carries, derived in ONE place so no component can compute them.
//
// `newPosition` is the big slot's OWN position, read off the entry and never arithmetic on the
// pointer: the table wraps forward past its end (…399, 0, 1), so `currentPosition + n` names a
// different code than the one on screen on every cerradura near the wrap — and the agent reads that
// code out loud. app-service's `task` context does add one, because there the position of the
// already-used code arrives; here the next-to-give arrives, so the value passes through untouched.
//
// Null when there is nothing to confirm: a carril the cerradura does not have, no painted window, or
// a big slot holding no code. An empty carril can therefore never produce a write.
export function lockSequenceTarget(
  rail: LockCodeRail | null,
  codeWindow: LockCodeWindow | null,
): LockSequenceTarget | null {
  if (rail === null || codeWindow?.next == null) return null;
  return { oldPosition: rail.currentPosition, newPosition: codeWindow.next.position };
}
